<template>
  <h2
    class="answerText"
    :style="[
      {
        color: siteSettings.textColor,
        fontSize: siteSettings.textSize
      },
      active ? hoverStyle : ''
    ]"
    @mouseover="hover"
    @mouseout="endHover"
  >
    {{ answerText }}
  </h2>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AnswerText",
  props: {
    answerText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    ...mapState(["siteSettings"]),
    hoverStyle() {
      return { color: this.siteSettings.accent };
    }
  },
  methods: {
    hover() {
      this.active = true;
    },
    endHover() {
      this.active = false;
    }
  }
};
</script>

<style lang="scss">
.answerText {
  margin: 6px;
}
</style>
